export default {"src":"/_next/static/media/transit-bike.9887e240.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};